import { EmployeeLevelEnum } from '../../../types'

export function mapPyramidLevelPillToEmployeeLevels(levelPill: string): EmployeeLevelEnum[] {
  if (levelPill === 'C1 - C2' || levelPill === 'C1-C2') {
    return [EmployeeLevelEnum.C1, EmployeeLevelEnum.C2]
  }
  if (levelPill === 'PR - M' || levelPill === 'PR-M') {
    return [EmployeeLevelEnum.Pr, EmployeeLevelEnum.M]
  }
  if (levelPill === 'SPR - SM' || levelPill === 'SPR-SM') {
    return [EmployeeLevelEnum.Spr, EmployeeLevelEnum.Sm]
  }

  if (Object.values(EmployeeLevelEnum).includes(levelPill as EmployeeLevelEnum)) {
    return [levelPill as EmployeeLevelEnum]
  }

  return []
}
